import request from '@/utils/request'

export function list(id) {

  return request({
    url: '/appointments/' + id,
    method: 'get',
  })
}

export function show(id) {

  return request({
    url: '/appointment/show/' + id,
    method: 'get',
    id
  })
}

export function loadIntent(id) {
  return request({
    url: '/get-payment-intent/' + id,
    method: 'get',
  })
}

export function savePaymentDetails(data) {
  return request({
    url: '/update-payment-status',
    method: 'post',
    data
  })
}

export function getAppointmentByUuid(uuid) {
  return request({
    url: '/get-appointment/' + uuid,
    method: 'get',
  })
}

export function joinRoom(data) {
  return request({
    url: '/join-room',
    method: 'post',
    data
  })
}

export function leftRoom(data) {
  return request({
    url: '/left-room',
    method: 'post',
    data
  })
}

export function setReminder(data) {

  return request({
    url: '/send-reminder/'+data.appointment_id,
    method: 'post'
  })
}

export function getFields(data) {
  return request({
    url: '/get-fields/'+ data,
    method: 'get',
  })
}


export function UpdateMissedCallFlag(data) {
  return request({
    url: '/miss-called-flag/update',
    method: 'post',
    data
  })
}

export function userAvailableUnavalibleEvent(data) {
  return request({
    url: 'user-available-unavailable-event',
    method: 'post',
    data
  })
}

export function getSettings(data) {
  return request({
    url: 'system-settings/get',
    method: 'get'
  })
}

export function getStaffAvailableSlot(data) {
  return request({
    url: 'staff-availaible-slot',
    method: 'post',
    data,
  })
}

export function setWaitingTime(data) {
  return request({
    url: '/waiting-time/update',
    method: 'post',
    data
  })
}


export function getCustomStyle(data) {
  return request({
    url: '/get-custom-style',
    method: 'post',
    data
  })
}

export function getQuestionFields(data) {
  return request({
    url: '/get-question-option-field',
    method: 'post',
    data
  })
}
export function saveEventChatMessage(data, onUploadProgress = null) {
  return request({
    url: 'save-individual-chat-message',
    method: 'post',
    onUploadProgress,
    data
  })
}

export function getAppointmentDetails(data) {
  return request({
    url: '/getappointmentdetail/'+data.id,
    method: 'get',
  }) 
}
export function getDefaultQuestionFields(data) {
  return request({
    url: '/get-default-question-option-field',
    method: 'post',
    data
  })
}
